// Devuelve valores unicos para un identificador dado
export function getUnique(array: any[], identificador: string) {
    const unique = array
        .map(e => e[identificador])
        .map((e, i, final) => final.indexOf(e) === i && i)
        .filter(e => array[e])
        .map(e => array[e]);

    return unique;
}